export default "__VITE_ASSET__DCQ_0_af__"